import React from "react";
import Modal from "../../modal/Modal";

export const TermsContent = () => (
  <div style={{ fontSize: 14, lineHeight: 1.6, color: "rgba(0,0,0,0.85)" }}>
    <p style={{ marginBottom: 16 }}>
      Gaming Board of The Bahamas — Digital Application Portal
    </p>

    <h3 style={{ fontSize: 16, marginTop: 16 }}>1. Acceptance of Terms</h3>
    <p>
      By creating an account and using this Digital Application Portal,
      you agree to these Terms and Conditions and to comply with all
      applicable laws and regulations of the Commonwealth of The Bahamas
      relating to gaming licensing and administration.
    </p>

    <h3 style={{ fontSize: 16, marginTop: 16 }}>2. Authorized Use</h3>
    <p>
      Access is provided for authorized company administrators and employees
      to submit, manage, and track gaming-related applications. You must
      keep your login credentials confidential and notify the Gaming Board
      of any unauthorized use of your account.
    </p>

    <h3 style={{ fontSize: 16, marginTop: 16 }}>3. Accuracy of Information</h3>
    <p>
      You are responsible for ensuring that all information and documents
      submitted through this portal are true, complete, and accurate.
      Providing false or misleading information may result in application
      rejection, account suspension, or further regulatory action.
    </p>

    <h3 style={{ fontSize: 16, marginTop: 16 }}>4. Documents and Data</h3>
    <p>
      Uploaded documents must be legitimate business or personal records
      required for your application. You must not upload malicious,
      unlawful, or unrelated files. The Gaming Board may retain submitted
      data as required for licensing, audit, and compliance purposes.
    </p>

    <h3 style={{ fontSize: 16, marginTop: 16 }}>5. Privacy</h3>
    <p>
      Personal and company information collected through this portal is
      used to process applications and administer related services. Data
      is handled in accordance with applicable Bahamian law and Gaming
      Board policies.
    </p>

    <h3 style={{ fontSize: 16, marginTop: 16 }}>6. System Availability</h3>
    <p>
      The portal is provided on an “as available” basis. The Gaming Board
      is not liable for temporary interruptions, maintenance downtime, or
      delays caused by circumstances beyond its reasonable control.
    </p>

    <h3 style={{ fontSize: 16, marginTop: 16 }}>7. Changes</h3>
    <p>
      These Terms and Conditions may be updated from time to time.
      Continued use of the portal after changes are published constitutes
      acceptance of the revised terms.
    </p>

    <h3 style={{ fontSize: 16, marginTop: 16 }}>8. Contact</h3>
    <p>
      For questions about these terms or your account, please contact the
      Gaming Board of The Bahamas service provider that issued your
      signup invitation.
    </p>
  </div>
);

const TermsAndConditionsModal = ({ show, handleClose }) => {
  return (
    <Modal
      show={show}
      handleClose={handleClose}
      colWidth={7}
      bodyStyle={{
        borderRadius: "10px",
        maxHeight: "85vh",
        overflow: "auto",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 12,
          marginBottom: 16,
        }}
      >
        <h5 style={{ margin: 0 }}>Terms and Conditions</h5>
        <button type="button" className="btn-close" onClick={handleClose} aria-label="Close" />
      </div>
      <TermsContent />
      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 20 }}>
        <button type="button" className="btn btn-primary" onClick={handleClose}>
          Close
        </button>
      </div>
    </Modal>
  );
};

export default TermsAndConditionsModal;
